import React from 'react';
import { StyledPaginationSortByComponentDiv } from './index.styles';
import clsx from 'clsx';
import { MSearchSummaryComponent } from '../MSearchResultsSummary';
import { renderedData } from '../../organisms/OSearchResults/searchResultsMainComponent';
import { MSortByFilterComponent } from '../MSortByFilter';
import { useConditionalSearchResultsRenderedDataSERP } from '../../hooks/lib/useConditionalRenderedData';

export const MPaginationSortByComponent: React.FC<{
  isMobileState: boolean;
  className: string;
  setFetchCurrencyConversionFactors: React.Dispatch<React.SetStateAction<boolean>>;
  segmentId?: string;
  isLatLongAvailable?: boolean;
  isCorpCodeEntered?: boolean;
  destinationType?: string;
}> = ({
  isMobileState,
  className,
  setFetchCurrencyConversionFactors,
  segmentId,
  isLatLongAvailable,
  isCorpCodeEntered,
  destinationType,
}) => {
  const { isMapViewEnabled } = useConditionalSearchResultsRenderedDataSERP(renderedData);
  return (
    <StyledPaginationSortByComponentDiv className={clsx('container', className, isMapViewEnabled ? `m-0` : ``)}>
      <div
        className={clsx(
          'container',
          'row-2',
          isMobileState && 'd-flex',
          isMobileState && 'pagination-sort-by-row',
          isMapViewEnabled ? `pr-3` : `pr-0`
        )}
      >
        <MSearchSummaryComponent />
        {false && (
          <MSortByFilterComponent
            isMobileState={isMobileState}
            segmentId={segmentId}
            isLatLongAvailable={isLatLongAvailable}
            setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
            isCorpCodeEntered={isCorpCodeEntered}
            destinationType={destinationType}
          />
        )}
      </div>
    </StyledPaginationSortByComponentDiv>
  );
};
